/**
 * Removes the static loading shape index.html puts over #root on a cold
 * `/chart` load (it exists so the tab is never blank while the script graph
 * arrives). A no-op everywhere else, where there is nothing to remove.
 */
export const dismissBootSplash = (): void => {
  document.getElementById('boot-splash')?.remove()
}
